export function getCreationForm(formElements: any, title:any): any {
  return [
    {
      type: "fgcardContainer",
      name: "Card Container",
      icon: "fa fa-columns",
      config: true,
      condition: {},
      isCoreConfig: true,
      children: [
        {
          type: "fgCardHeader",
          name: "Card Header",
          icon: "fa fa-square-o",
          config: true,
          class: "card-header",
          children: [
            {
              type: "fgrow",
              id: "12223aaa",
              name: "Row",
              icon: "fa fa-bars",
              config: false,
              logo: "fgrow",
              condition: {},
              isCoreConfig: true,
              children: [
                {
                  type: "fgcol",
                  id: "10168zv98735",
                  span: "6",
                  icon: "fa fa-columns",
                  config: false,
                  name: "6 Columns",
                  logo: "fgcol",
                  children: [
                    {
                      type: "fgword",
                      subtype: "h4",
                      cat: "HEADING",
                      name: "Heading 1",
                      text: title,
                      condition: {},
                      isCoreConfig: true,
                      category: "STATIC",
                      uuid: crypto.randomUUID(),
                      textAlign: "text-left",
                      styles: {},
                    },
                  ],
                  uuid:crypto.randomUUID(),
                },
                {
                  type: "fgcol",
                  id: "0908jh5553",
                  span: "6",
                  icon: "fa fa-columns",
                  config: false,
                  name: "6 Columns",
                  logo: "fgcol",
                  children: [
                    {
                      type: "fgbuttonaction",
                      subtype: "formaction",
                      icon: "fa fa-plus",
                      name: "Form Button",
                      condition: {},
                      isCoreConfig: true,
                      category: "ACTIONS",
                      uuid:crypto.randomUUID(),
                      actionPurposeCode: "authorise",
                      setValueConfig: {},
                      messageConfigs: "aftereSubmitMessage",
                      messageConfig: {},
                      afterMessageConfigs: {},
                      option: { page: {} },
                      customReqFieldConfig: {},
                      styles: {},
                        class:"ml-3",
                      label: "Cancel",
                      dynamicLabel: false,
                      actionCode: "Cancel",
                    },
                    {
                      type: "fgbuttonaction",
                      subtype: "formaction",
                      icon: "fa fa-plus",
                      name: "Form Button",
                      condition: {},
                      isCoreConfig: true,
                      category: "ACTIONS",
                      uuid: crypto.randomUUID(),
                      actionPurposeCode: "authorise",
                      setValueConfig: {},
                      messageConfigs: "aftereSubmitMessage",
                      messageConfig: {},
                      afterMessageConfigs: {},
                      option: {
                        page: {},
                      },
                      customReqFieldConfig: {},
                      styles: {},
                      class:"ml-3",
                      label: "Submit",
                      dynamicLabel: false,
                      actionCode: "Submit",
                      manualMapping: false,
                    },
                  ],
                  uuid:crypto.randomUUID(),
                  condition: {},
                  styles: {},
                  customClass: "text-right",
                  isValidate: true
                },
              ],
              category: "GRIDS",
              uuid: crypto.randomUUID(),
            },
          ],
          condition: {},
          isCoreConfig: true,
          category: "LAYOUT",
          isHiddenInCategory: true,
          uuid: crypto.randomUUID(),
        },
        {
          type: "fgCardBody",
          name: "Card Body",
          icon: "fa fa-square-o",
          config: true,
          class: "card-body",
          children: [
            {
              type: "fgcustomcontainer",
              name: "Custom Container",
              icon: "fa fa-square-o",
              class: "card-default",
              header: true,
              heading: " some heading",
              config: true,
              children: formElements,
              condition: {},
              isCoreConfig: true,
              category: "LAYOUT",
              uuid: crypto.randomUUID(),
              displayContainer: "FORM_CONTAINER",
              styles: {},
            },
          ],
          condition: {},
          isCoreConfig: true,
          category: "GENERAL",
          isHiddenInCategory: true,
          uuid:crypto.randomUUID(),
        },
      ],
      category: "LAYOUT",
      disableAdd: true,
      uuid: crypto.randomUUID(),
      styles: {},
    },
  ];
}
